import usePermissions from "../../hooks/usePermissions";
import Page from "../../components/Page";
import React from "react";

const PageContainer = (props: any) => {
  const permissions = usePermissions();

  return (
    <Page title={props.title} permissions={permissions}>
      {props.children}
    </Page>
  );
};

export default PageContainer;
